import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { InstiService } from '../../insti/insti.service';
import { TreeNode } from './models/treenode';
import { LocalDataSource } from 'ng2-smart-table';
import {SistemaOrcamentarioService} from './sistema-orcamentario.service';


@Injectable({  
  providedIn: 'root'
})
export class BaseOrcService extends InstiService{
    protected current_orc_id:number;
    protected current_orc_dados:any;
    protected isLocalFiles=true; 

    protected orc_instance_service:SistemaOrcamentarioService
    lotCargoSal:any; 
    
    constructor(
        protected http: HttpClient        
    ) {
      super();
    }
     setOrcInstance(value){
        this.orc_instance_service=value;
        return this;
    } 
    hasOrcInstance(){
        let orc=this.getOrcService();
        return !orc ? false : true;
    }
    /**
     * ================== PROXY PARA OS METODOS DO ORC SERVICE ===================
     */
    isValidOrc(){ return this.hasOrcInstance()? this.getOrcService().isValidOrc() : false; }
    isEditableOrc(){ return this.hasOrcInstance()? this.getOrcService().isEditableOrc() : false;}
    getOrcService(){ return this.orc_instance_service; }
    hasOrc(){ return this.hasOrcInstance()? this.getOrcService().hasOrc() : false; }
    getId(){ return this.hasOrcInstance()? this.getOrcService().getId() : 0;}
    getDados(){ 
            let service=this.getOrcService();
            let metodo="getDados";
        return this.hasOrcInstance()? service[metodo]() : null;
    } 
    getLotacaoAtualId(){     
        try{   
         return this.getOrcService().getLotacaoAtualId();
        }
        catch(error){
        }
        return 1;
     } 
     getCargoAtualId(){
         return this.getOrcService().getCargoAtualId();
     }

     getTipoTable(){
         return this.hasOrcInstance()? this.getOrcService().getTipoTable() : 'O';
     }

     approveBudget(orc_id,success,error){
         return this.doHttp(`orcamento/${orc_id}/aprovar`,'post',success,error,orc_id);
     }
    /**
     * ============= FIM DO PROXY PARA OS METODOS DO ORC SERVICE ==================
     */     
    listarCronograma(orc_id,success,error=null){
        return this.doHttp(`orcamento/${orc_id}/cronograma/listar`,'post',success,error,orc_id);
    }
    
    importarExcel(orc_id, form_data, tbl_name, tipo_table, periodo, success, error?){
        let instance = this; 
        return instance.doHttp(`orcamento/${orc_id}/lotacao/${form_data.lotacao_id}/${tbl_name}/${periodo}/${tipo_table}/importar`,'post',success,error,form_data);
    }
    salvarAtividadeLotacao(dados,orc_id,success,error){
        return this.doHttp(`orcamento/${orc_id}/cronograma/lotacao/insert`,'post',success,error,dados);
    }
    updateAtividadeLotacao(dados,orc_id,success,error){
        return this.doHttp('orcamento/'+ orc_id +'/cronograma/update','post',success,error,dados);
    }
    deleteAtividadeLotacao(dados,orc_id,success,error){
        return this.doHttp('orcamento/'+orc_id+'/cronograma/delete','post',success,error,dados);
    }
}
 